// extracted by mini-css-extract-plugin
export var deliveryRow = "_rr-a";
export var fixedHeight = "_rr-4";
export var freightLogo = "_rr-9";
export var fullWidth = "_rr-3";
export var priceColumn = "_rr-5";
export var radioSelected = "_rr-7";
export var radioUnselected = "_rr-6";
export var selectedOption = "_rr-2";
export var selectedOptionContainer = "_rr-1";
export var selection = "_rr-0";
export var tallSkeletonText = "_rr-8";